import gql from "graphql-tag";
import { expenseFragment } from "@/graphql/expenses/fragments";

export const CREATE_EXPENSE = gql`
  mutation createExpense(
    $projectId: ID!
    $name: String!
    $date: Date!
    $costNet: Int!
    $costGross: Int!
    $quantity: Int!
    $alreadyInvoiced: Boolean
  ) {
    createExpense(
      projectId: $projectId
      name: $name
      date: $date
      costNet: $costNet
      costGross: $costGross
      quantity: $quantity
      alreadyInvoiced: $alreadyInvoiced
    ) {
      status
      error
      data {
        ...ExpenseFragment
      }
    }
  }
  ${expenseFragment}
`;

export const DELETE_EXPENSE = gql`
  mutation deleteExpense($id: ID!) {
    deleteExpense(id: $id) {
      status
      error
      data {
        ...ExpenseFragment
      }
    }
  }
  ${expenseFragment}
`;

export const UPDATE_EXPENSE = gql`
  mutation updateExpense(
    $id: ID!
    $name: String
    $date: Date
    $costNet: Int
    $costGross: Int
    $quantity: Int
    $alreadyInvoiced: Boolean
  ) {
    updateExpense(
      id: $id
      name: $name
      date: $date
      costNet: $costNet
      costGross: $costGross
      quantity: $quantity
      alreadyInvoiced: $alreadyInvoiced
    ) {
      status
      error
      data {
        ...ExpenseFragment
      }
    }
  }
  ${expenseFragment}
`;
